// Firebase refs live here instead of in Vuex state: a ref in reactive state lets Vue
// deep-observe the SDK's whole in-memory cache (~40x memory), which crashes iOS Safari tabs.
const listeners = {
  deliveries: null,
  zones: null
}

export const getListener = name => listeners[name]

export const setListener = (name, ref) => {
  listeners[name] = ref
}

export const detachListener = name => {
  if (listeners[name]) listeners[name].off()
  listeners[name] = null
}
